import { endOfDay, startOfDay } from 'date-fns'
import { action, computed, observable, makeObservable } from 'mobx'
import { IFilterViewModel } from 'infra/FiltersViewModel'

export interface DateRange {
  from: Date | null
  to: Date | null
}

export class DateRangeFilter<TKey>
  implements IFilterViewModel<TKey, DateRange>
{
  key: TKey
  title: string
  @observable value: DateRange | null = null
  @observable editing = false

  constructor(key: TKey, title: string) {
    makeObservable(this)
    this.key = key
    this.title = title
  }

  @computed
  get valid() {
    return Boolean(this.value?.from || this.value?.to)
  }

  toString() {
    if (!this.value?.from && !this.value?.to) {
      return ''
    }

    if (!this.value?.from) {
      return `${this.title} to: ${this.value?.to?.toLocaleDateString()}`
    }
    if (!this.value?.to) {
      return `${this.title} from: ${this.value?.from?.toLocaleDateString()}`
    }

    return `${
      this.title
    }: ${this.value?.from?.toLocaleDateString()} - ${this.value?.to?.toLocaleDateString()}`
  }

  @action.bound
  setTo(val: Date) {
    this.value = {
      from: this.value?.from ?? null,
      to: val ? endOfDay(val) : null,
    }
  }

  @action.bound
  setFrom(val: Date) {
    this.value = {
      from: val ? startOfDay(val) : null,
      to: this.value?.to ?? null,
    }
  }

  @action.bound
  clearValue() {
    this.value = null
  }

  @action.bound
  startEditing() {
    this.editing = true
  }

  @action.bound
  stopEditing() {
    this.editing = false
  }

  /**
   * ToDo: implement in order to support storing
   */
  serialize() {
    return null
  }

  /**
   * ToDo: implement in order to support storing
   */
  deserialize() {
    // not done yet
  }
}
